export interface IWithIdAndTitle {
  id: string;
  title: string;
}
